import { render, staticRenderFns } from "./exhibitionServices.vue?vue&type=template&id=ff68ec70&scoped=true&"
import script from "./exhibitionServices.vue?vue&type=script&lang=js&"
export * from "./exhibitionServices.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionServices.vue?vue&type=style&index=0&id=ff68ec70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff68ec70",
  null
  
)

export default component.exports